"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEFAULT_OPTIONS = {
    precision: 'minutes'
};
const TEXTS = {
    default: {
        second: 'second',
        seconds: 'seconds',
        minute: 'minute',
        minutes: 'minutes',
        hour: 'hour',
        hours: 'hours',
        day: 'day',
        days: 'days',
        month: 'month',
        months: 'months',
        year: 'year',
        years: 'years'
    },
    de: {
        second: 'Sekunde',
        seconds: 'Sekunden',
        minute: 'Minute',
        minutes: 'Minuten',
        hour: 'Stunde',
        hours: 'Stunden',
        day: 'Tag',
        days: 'Tage',
        month: 'Monat',
        months: 'Monate',
        year: 'Jahr',
        years: 'Jahre'
    }
};
const translateUnit = (count, unit, locale) => {
    const texts = TEXTS[locale] || TEXTS.default;
    return count === 1 ? texts[unit] : texts[unit + 's'];
};
const preciseDiff = (_options, dayjsClass, dayjsFactory) => {
    dayjsClass.prototype.preciseDiff = function (d2, options = DEFAULT_OPTIONS) {
        let m1 = dayjsFactory(this);
        let m2 = dayjsFactory(d2);
        if (m1.isSame(m2))
            return '';
        if (m1.isAfter(m2)) {
            const tmp = m1;
            m1 = m2;
            m2 = tmp;
        }
        let yDiff = m2.year() - m1.year();
        let mDiff = m2.month() - m1.month();
        let dDiff = m2.date() - m1.date();
        let hourDiff = m2.hour() - m1.hour();
        let minDiff = m2.minute() - m1.minute();
        let secDiff = m2.second() - m1.second();
        if (secDiff < 0) {
            secDiff = 60 + secDiff;
            minDiff--;
        }
        if (minDiff < 0) {
            minDiff = 60 + minDiff;
            hourDiff--;
        }
        if (hourDiff < 0) {
            hourDiff = 24 + hourDiff;
            dDiff--;
        }
        if (dDiff < 0) {
            const daysInLastFullMonth = dayjsFactory(m2.year() + '-' + (m2.month() + 1))
                .subtract(1, 'M')
                .daysInMonth();
            if (daysInLastFullMonth < m1.date()) {
                // 31/01 -> 2/03
                dDiff = daysInLastFullMonth + dDiff + (m1.date() - daysInLastFullMonth);
            }
            else {
                dDiff = daysInLastFullMonth + dDiff;
            }
            mDiff--;
        }
        if (mDiff < 0) {
            mDiff = 12 + mDiff;
            yDiff--;
        }
        const valueObject = {
            year: yDiff,
            month: mDiff,
            day: dDiff,
            hour: hourDiff,
            minute: minDiff,
            second: secDiff
        };
        const precisionIndex = Object.keys(valueObject).findIndex((unit) => { var _a; return unit === ((_a = options.precision) === null || _a === void 0 ? void 0 : _a.replace(/s$/, '')); });
        const filteredUnits = Object.keys(valueObject).slice(0, precisionIndex + 1);
        return Object.entries(valueObject)
            .filter(([unit, value]) => filteredUnits.includes(unit) && !isNaN(value) && value > 0)
            .map(([unit, value]) => [value, translateUnit(value, unit, this.locale())].join(' '))
            .join(' ');
    };
};
exports.default = preciseDiff;
